<template>
    <div id="modal-subscription-transaction-create-form" class="modal fade" tabindex="-1" role="dialog"
         style="display: none;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title font-normal" id="modalTitle">New Transaction</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
                            @click.prevent="hideTransactionCreateForm">×
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form">

                        <!--Date-->
                        <div class="form-group">
                            <label for="next_reminder_date">Date</label>
                            <div id="next_reminder_date" class="w-100">
                                <el-date-picker prefix-icon="none" align="center" clearable
                                                v-model="newTransactionForm.date"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                class="no-icon w-100"
                                                size="large">
                                </el-date-picker>
                            </div>
                        </div>

                        <!--Type-->
                        <div class="form-group">
                            <label for="type">Type</label>
                            <div id="type">
                                <el-select class="w-100" v-model="newTransactionForm.type" placeholder="Select type">
                                    <el-option value="debit" label="Debit"></el-option>
                                    <el-option value="credit" label="Credit"></el-option>
                                </el-select>
                            </div>
                            <span class="invalid-feedback" :class="{'d-block': newTransactionForm.errors.has('type')}"
                                  v-show="newTransactionForm.errors.has('type')">{{ newTransactionForm.errors.get("type") }}
                        </span>
                        </div>

                        <!--category-->
                        <div class="form-group">
                            <label for="category">Category</label>
                            <div id="category">
                                <el-select class="w-100" v-model="newTransactionForm.category"
                                           placeholder="Select Category">
                                    <el-option v-for="option in categoryOptions" :key="option" :value="option"
                                               :label="option | capitalize"></el-option>
                                </el-select>
                            </div>
                            <span class="invalid-feedback"
                                  :class="{'d-block': newTransactionForm.errors.has('category')}"
                                  v-show="newTransactionForm.errors.has('category')">{{ newTransactionForm.errors.get("category") }}
                        </span>
                        </div>

                        <!--Description-->
                        <div class="form-group">
                            <div class="form-group mb-2">
                                <label for="description" style="font-weight: 400">Description</label>
                                <input class="form-control" type="text" id="description" name="description"
                                       v-model="newTransactionForm.description"
                                       :class="{'is-invalid': newTransactionForm.errors.has('description')}">

                                <span class="invalid-feedback" v-show="newTransactionForm.errors.has('description')">
                                 {{ newTransactionForm.errors.get("description") }}
                             </span>
                            </div>
                        </div>


                        <!--Total Including VAT-->
                        <div class="form-group">
                            <label class="mb-2" style="font-weight: 400">Total Including VAT</label>
                            <div>
                                <div class="input-group form-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">ZAR</span>
                                    </div>
                                    <input type="text" class="form-control"
                                           v-model="newTransactionForm.total_incl"
                                           :class="{'is-invalid': newTransactionForm.errors.has('total_incl')}">
                                </div>
                                <span class="invalid-feedback"
                                      v-show="newTransactionForm.errors.has('total_incl')">
                             {{ newTransactionForm.errors.get("total_incl") }}
                            </span>
                            </div>
                        </div>

                    </div>
                </div>


                <div class="modal-footer">
                    <button class="btn btn-success waves-effect waves-light"
                            @click.prevent="createTransaction"
                            :disabled="newTransactionForm.busy">
                        Create
                    </button>
                    <button type="button" class="btn btn-default waves-effect" data-dismiss="modal"
                            @click.prevent="hideTransactionCreateForm"
                            :disabled="newTransactionForm.busy">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "create-subscription-transaction",

        props: ["subscriptionId"],

        data () {
            return {
                newTransactionForm: new AppForm({}),
                categoryOptions: [
                    "licence fees",
                    "admin fees",
                    "training fees",
                    "sms fees",
                    "other",
                    "debit order collection",
                    "credit note",
                    "debit note",
                ]
            };
        },

        methods: {
            showTransactionCreateForm () {
                $("#modal-subscription-transaction-create-form").modal("show");
            },

            hideTransactionCreateForm () {
                $("#modal-subscription-transaction-create-form").modal("hide");
                this.newTransactionForm = new AppForm({});
            },

            createTransaction () {
                App.post("/subscriptions/" + this.subscriptionId + "/transactions/create", this.newTransactionForm)
                .then((response) => {
                    this.$emit("new-transaction-added", response.transaction, response.accountBalance);
                    toastr.success("New Transaction Added");
                    this.hideTransactionCreateForm();
                }).catch(() => {
                    toastr.error("Could not create this transaction!");
                });
            },
        }
    };
</script>

<style scoped>

</style>
